const __WEBPACK_NAMESPACE_OBJECT__ = require("vue-property-decorator");